export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";